import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router';
import './CSS/ShippingInfo.css';
import { ShopContext } from '../Context/ShopContext';
import { Circles } from 'react-loader-spinner';

const ShippingInfo = () => {
  const [form, setForm] = useState({ name: '', address: '', phone: '', email: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { setCartItems, setAll_Product } = useContext(ShopContext); // ⬅️ kiegészítve

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const { name, address, phone, email } = form;
    if (!name || !address || !phone || !email) {
      setError("Kérlek tölts ki minden mezőt!");
      return;
    }

    setLoading(true);
    setError('');

    try {
      const couponCode = localStorage.getItem("couponCode");
      const discountPercentage = Number(localStorage.getItem("discountPercentage")) || 0;
      const itemDecorations = JSON.parse(localStorage.getItem("decorations") || '{}');

      const response = await fetch("/api/placeorder", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": localStorage.getItem("auth-token")
        },
        body: JSON.stringify({
          ...form,
          couponCode,
          discountPercentage,
          itemDecorations
        })
      });

      if (!response.ok) {
        const text = await response.text(); // ❗ Olvasd be simán a szöveget
        throw new Error(`HTTP hiba: ${response.status} - ${text}`);
      }

      const data = await response.json();

      if (data.success) {
        let emptyCart = {};
        for (let i = 0; i < 300; i++) emptyCart[i] = 0;
        setCartItems(emptyCart);
        setAll_Product([]); // ha szeretnéd a contextben is üríteni
        localStorage.removeItem("decorations");
        localStorage.removeItem("couponCode");
        localStorage.removeItem("discountPercentage");
        navigate("/order-success");
      } else {
        console.error("Szerver válasz:", data);
        alert("Hiba a rendelés leadásakor: " + (data.message || "Ismeretlen hiba"));
      }

    } catch (error) {
      console.error("Hálózati vagy parse hiba:", error);
      alert("Sikertelen kapcsolat a szerverrel.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="shipping-form">
      {loading ? (
        <div className="loader-container">
          <Circles height="80" width="80" color="#4fa94d" ariaLabel="circles-loading" visible={true} />
          <p>Rendelés feldolgozása folyamatban...</p>
        </div>
      ) : (
        <>
          <h2>Szállítási információk</h2>
          <input name="name" placeholder="Név" value={form.name} onChange={handleChange} required />
          <input name="email" placeholder="Email cím" value={form.email} onChange={handleChange} required />
          <input name="address" placeholder="Cím (pl. 9700 Szombathely, Kőszegi utca 19.)" value={form.address} onChange={handleChange} required />
          <input name="phone" placeholder="Telefonszám" value={form.phone} onChange={handleChange} required />
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <button onClick={handleSubmit}>Rendelés leadása</button>
        </>
      )}
    </div>
  );
};

export default ShippingInfo;
